import styled from 'styled-components'

export const Wrapper = styled.span`
  [role='button'] {
    margin: 0 !important;
    cursor: default !important;
  }
`

Wrapper.displayName = 'Wrapper'
